import React from "react";
import hero1 from '../../images/slider/img-4.webp'
import shape from '../../images/slider/shape.png'
import { Link } from 'react-scroll'
import BlurText from './BlurText';
import MarqueeSec from '../MarqueeSec/MarqueeSec';
import './hero4.css';

const Hero4 = () => {
    return (
        <section className="wpo-hero-style-4" id="home">
            <div className="hero-shell">
                <div className="wpo-hero-content">
                    <div className="wpo-hero-text">
                        <span className="hero-greeting fade-in-up">Hello I'm <span>Isuru Gimhan</span></span>
                        <h1>
                            <BlurText text="A Creative Designer Who Solves Problems Through Designs" className="blur-hero" duration={1200} delay={0} />
                        </h1>
                    </div>
                    <div className="slide-btns fade-in-up">
                        <Link to="contact" spy={true} smooth={true} duration={500} className="theme-btn-s3"><span>Let's Get Started</span></Link>
                    </div>
                </div>
                <div className="wpo-hero-figure">
                    <div className="glitch-fade-in">
                        <img src={hero1} alt="Isuru Gimhan - Freelance Designer and Developer" />
                    </div>
                </div>
            </div>
            <MarqueeSec />
            <div className="light-shape-1"></div>
            <div className="light-shape-2"></div>
            <div className="light-shape-3"></div>
            <div className="shape-bg">
                <img src={shape} alt="decorative shape" />
            </div>
        </section>
    )
}

export default Hero4;